// eslint-disable-next-line no-redeclare
import { useContext } from 'react';
import { addUrlParams } from '../Dialogs/FileModalDialog';
import { DocumentContext } from '../../Service/Context/DocumentContextV2';
import DocumentTemplatePreview from './DocumentTemplatePreview';

const DocumentPreview = () => {
  const { bookitupDocument, savePatch, negativeSum, handleChange } = useContext(DocumentContext);
  if (!bookitupDocument) {
    return null;
  }
  const { eventId, id: documentId, draft } = bookitupDocument;

  return (
    <DocumentTemplatePreview
      portalSupported
      entityType="documents"
      entity={bookitupDocument}
      draft={draft}
      url={`${process.env.REACT_APP_DOCUMENT_SERVICE_URL}/${documentId ? 'existing' : 'generate'}?${addUrlParams({
        eventId,
        documentId,
      })}`}
      patchEntity={savePatch}
      isPrintable={!negativeSum}
      handleChange={handleChange}
    />
  );
};

export default DocumentPreview;
